import { ReactElement } from 'react';
import { SGMEndpointConfigs } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicTable } from '../../magic/MagicTable';

export interface SGMEndpointConfigsTableProps {
  endpoints: SGMEndpointConfigs[];
  loading?: boolean;
  selectable?: boolean;
  onSelect?: (ids: string[]) => unknown;
}

export const SGMEndpointConfigsTable = ({
  endpoints,
  loading,
  selectable,
  onSelect,
}: SGMEndpointConfigsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('SGM')}
    entry="EndpointConfigSummary"
    idAttribute="EndpointConfigName"
    rows={endpoints}
    selectable={selectable}
    onSelect={onSelect}
    order={['EndpointConfigName']}
    loading={loading}
  />
);
